import { dateHeader, formatCellDate } from './timeModeCell';
import { linkTo } from '../linkTo';
import { ColumnExtended } from '../../types/ColumnExtended';

export const makeCollectionDetailColumn = (): ColumnExtended<any>[] => {
  return [
    {
      header: 'Serial Number',
      accessorKey: 'resourceId',
      id: 'serialNumber',
      enableColumnFilter: true,
      size: 150,
      cell: ({ row }) => {
        const equipment = row.original.equipment;
        const serialNumber = equipment?.serialNumber;
        if (serialNumber) {
          return linkTo('/equipment', equipment.id, serialNumber, '_blank');
        }
        return row.original.resourceId ?? row.original.secondarySubjectId ?? '';
      },
    },
    {
      header: 'DeviceId',
      accessorKey: 'deviceId',
      enableColumnFilter: true,
      size: 180,
      cell: ({ row }) => {
        const device = row.original.device;
        const deviceId = device?.deviceId;

        return deviceId ? linkTo('/devices', deviceId, deviceId, '_blank') : null;
      },
    },
    {
      header: 'ULD Status',
      accessorKey: 'statusDescr',
      enableColumnFilter: false,
      size: 100,
      cell: ({ row }) => {
        const equipment = row.original.equipment;
        return equipment && equipment.statusDescr;
      },
    },
    {
      header: 'Network',
      accessorKey: 'networkCarrierCode',
      enableColumnFilter: false,
      size: 80,
      cell: ({ row }) => {
        const equipment = row.original.equipment;
        return equipment && equipment.networkCarrierCode;
      },
    },
    {
      header: 'Condition Code',
      accessorKey: 'ConditionCode',
      enableSorting: true,
      enableColumnFilter: false,
      size: 120,
      cell: ({ row }) => {
        const equipment = row.original.equipment;
        return equipment && equipment.contentCode;
      },
    },
    {
      header: 'Condition',
      accessorKey: 'condition',
      enableSorting: true,
      enableColumnFilter: false,
      size: 100,
      cell: ({ row }) => {
        const equipment = row.original.equipment;
        return equipment && equipment.condition;
      },
    },
    {
      header: 'Tag Health',
      accessorKey: 'isDeviceHealthy',
      enableColumnFilter: false,
      size: 100,
      cell: ({ row }) => {
        const { isDeviceHealthy, deviceNotHealthyReasons } = row.original;

        // Safely extract reasons if available
        const reasons =
          Array.isArray(deviceNotHealthyReasons) && deviceNotHealthyReasons.length > 0
            ? deviceNotHealthyReasons.map((reason: any) => reason?.value).join(', ')
            : 'Unknown';

        const title = isDeviceHealthy ? 'Healthy' : isDeviceHealthy === false ? reasons : '';

        return <span title={title}>{isDeviceHealthy == null ? '' : isDeviceHealthy ? 'Healthy' : 'Unhealthy'}</span>;
      },
    },
    {
      header: dateHeader('Created'),
      accessorKey: 'createdDateTime',
      enableSorting: true,
      size: 110,
      cell: ({ row, table }) => {
        const device = row.original.device;
        const createdDateTime = device?.createdDateTime;
        return createdDateTime && formatCellDate(table, createdDateTime);
      },
    },
    {
      header: dateHeader('Modified'),
      enableSorting: true,
      accessorKey: 'modifiedDateTime',
      size: 110,
      cell: ({ row, table }) => {
        const device = row.original.device;
        const modifiedDateTime = device?.modifiedDateTime;
        return modifiedDateTime && formatCellDate(table, modifiedDateTime);
      },
    },
  ];
};
